/**
 * @module cercaliagl/view/VLayerSwitcher
 */

import $ from 'jquery';
import BaseView from './BaseView';

/**
 * @typedef {Object} Item
 * @property {string} id
 * @property {string} value
 */

/**
 * @enum {string}
 */
export const EventType = {
  SELECTED: 'select',
  DESELECTED: 'deselect',
};

/**
 * @classdesc
 *
 */
class VLayerSwitcher extends BaseView {
  /**
   * @constructor
   * @param {boolean} [twoState] Two state. Elements could be enabled or disabled.
   */
  constructor(twoState) {
    const jqElement = $('<div class="v-layer-switcher mdc-elevation--z4"><ul class="mdc-list collection"/></div>');

    super(jqElement);

    /**
     * @private
     * @type {boolean}
     */
    this.twoState_ = twoState !== undefined ? twoState : false;

    /**
     * @private
     * @type {Object.<string, JQuery>}
     */
    this.items_ = {};

    /**
     * @private
     * @type {Item|null}
     */
    this.selected_ = null;
  }

  /**
   * @param {Item} item Item
   */
  add(item) {
    this.items_[item.id] = $(`
      <li href="#!" data-id="${item.id}" class="mdc-list-item collection-item">
        <span class="mdc-list-item__text">${item.value}</span>
        ${item.iconName ? `<span class="${item.iconName}"></span>` : ''}
      </li>`)
      .on('click', () => {
        if (!this.twoState_) {
          this.setSelected(item.id);
          this.eventEmitter_.emit(EventType.SELECTED, item);
        } else if (this.selected_) {
          this.setSelected(null);
          this.eventEmitter_.emit(EventType.DESELECTED, item);
        } else {
          this.setSelected(item.id);
          this.eventEmitter_.emit(EventType.SELECTED, item);
        }
      })
      .appendTo(this.jqElement_.find('ul'));

    if (!this.selected_ && !this.twoState_) {
      this.setSelected(item.id);
    }
  }

  /**
   * @param {string} id Id
   */
  setSelected(id) {
    if (id) {
      this.jqElement_.find('li').removeClass('mdc-list-item--activated');
      this.jqElement_.find(`li[data-id=${id}]`).addClass('mdc-list-item--activated');
      this.selected_ = this.items_[id];
    } else {
      this.jqElement_.find('li').removeClass('mdc-list-item--activated');
      this.jqElement_.find(`li[data-id=${id}]`).removeClass('mdc-list-item--activated');
      this.selected_ = null;
    }
  }

  /**
   * @param {string} id Id
   */
  remove(id) {
    this.jqElement_.remove(this.items_[id]);
    delete this.items_[id];
  }
}

export default VLayerSwitcher;
